<template>
    <div>
        <MercenaryHeader :title="'공지사항'" :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div style="padding:12px;">
            <div style="height:10px;"></div>
            <div style="color:#210F03; font-size:16px; font-weight:500;">트레이닝 공지사항을 등록하세요</div>
            <div style=" color:#808080; font-size:12px; font-weight:500; margin-top:3px;">공지사항은 최대 3개까지 등록할 수 있습니다.</div>

            <div style="height:20px;"></div>
            <div class="input_wrap" >
                <div class="label">첫 번째 공지</div>
                <input style="" v-model="contents[0]" placeholder="내용을 입력하세요" class="text_area" type="text" />
            </div>
            <div class="input_wrap">
                <div class="label">두 번째 공지</div>
                <input style="" v-model="contents[1]" placeholder="내용을 입력하세요" class="text_area" type="text" />
            </div>
            <div class="input_wrap">
                <div class="label">세 번째 공지</div>
                <input style="" v-model="contents[2]" placeholder="내용을 입력하세요" class="text_area" type="text" />
            </div>

            <div @click="saveNotice" style="margin-top:30px; display:grid; place-items: center; height:48px; color:white; font-size:14px; font-weight:bold; border-radius:12px; background-color: var(--color-main)">저장하기</div>
        </div>
    </div>
</template>

<script>
    import MercenaryHeader from "../../common/MercenaryHeader";
    import ResponseCode from "../../../ResponseCode";
    export default {
        name: "TeamTrainingNoticeForm",
        components: {MercenaryHeader},
        props : {
            join_schedule_idx : {
                type : [Number, String],
                default : -1
            },
            completeAction: {
                type: Function,
                default: () => {}
            },
        },
        data(){
            return {
                contents: ['', '', ''],
                noticeList: [],
                is_loaded : false,
            }
        },
        methods : {
            async saveNotice() {
                if(!this.is_loaded){
                    this.$GlobalStore.showToast('로딩중입니다. 잠시만 기다려주세요.');
                    return;
                }
                const formData = new FormData();
                formData.append('refer_idx', this.join_schedule_idx);
                formData.append('contents', JSON.stringify(this.contents));

                const res = await this.$Axios.post('/api/join/schedule/notice/save', formData)

                if (res.data.code === ResponseCode.SUCCESS) {
                    this.$GlobalStore.closeLastModal();
                    this.$GlobalStore.showToast('공지가 등록됐습니다.');
                    this.completeAction()
                } else {
                    this.$GlobalStore.showAlert(res.data.msg)
                }
            },
            async getNoticeList() {
                const parameters = {}

                parameters.refer_idx = this.join_schedule_idx

                const res = await this.$Axios.get('/api/join/schedule/notice', { params: parameters })
                this.is_loaded = true;
                const noticeList = res.data.notice_list

                this.noticeList = noticeList

                if (this.noticeList.length > 0) {
                    this.noticeList.forEach((item, index) => {
                        this.$set(this.contents, index, item.contents);
                    });
                }
            },
        },
        created() {
            this.saveNotice = this.$Once(this.saveNotice);
            this.getNoticeList()
        }
    }
</script>

<style scoped>
    .input_wrap{margin-top:20px;}
    .label{font-size:12px; color:#606060; margin-bottom:5px;}
    .text_area{background-color: #F5F5F5; border-radius:12px; height:40px; outline: none; border:0px; color:#210F03; font-size:14px; font-weight:500; padding:10px; width:100%;}
    .text_area::placeholder{color:#BBBBBB; font-size:14px;}
</style>